import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Layout from '../../../components/Layout'
import { useParams } from 'react-router-dom'
import PeriodeRpjmdSelector from '../../../components/PeriodeRpjmdSelector'
import { getDataIup_newSakatoplan_act } from '../../../../redux/ducks/newsakatoplan/actions'
import BackButton from '../../../components/BackButton'

const DataIup = ({ periodeState, getDataIup, iupState }) => {
    const [listYear, setListYear] = React.useState([2025,2026,2027,2028,2029,2030])
    const { yearconfig } = useParams()
    const [selectedPeriode, setSelectedPeriode] = React.useState(null)
    const [periodeData, setPeriodeData] = React.useState(null)
    const initBreadcrumbs = [
        {
          title: 'Home',
          isActive: true,
          goTo: '/tahun/'+yearconfig,
        },
        {
          title: `Indikator Utama Pembangunan`,
          isActive: false,
          goTo: '',
        },
    ];
    // const onchangeperiode = (e) => {
    //     setSelectedPeriode(e.target.value)
    //     let data = null
        
    //     periodeState.data.map((item) => { if(item.id == e.target.value){
    //         data = item;
            
    //     } } )
    //     setPeriodeData(data)
    //     if(e.target.value !== ""){
    //         getDataIup(e.target.value)
    //     }
    // }
    // React.useEffect(() => {
    //     if(periodeData){
    //         let asd = []
    //         for(let a = periodeData.awal; a<=periodeData.akhir; a++){
    //             asd.push(a)
    //         }
    //         setListYear(asd)
    //     }
        
    // },[periodeData])

    // React.useEffect(() => {
    //     if(periodeState.data.length > 0){
    //         let e = {
    //             target: {
    //                 value: 2
    //             }
    //         }
    //         onchangeperiode(e)
    //     }
    // },[])

    React.useEffect(() => { getDataIup(2) },[])

    const [breadCrumbsData, setBreadCrumbsData] = React.useState();
    React.useEffect(() => {
        setBreadCrumbsData(initBreadcrumbs)
    },[])

    const renderIndikator = (list) => {
        return list?.map((val, keys) => {
            return (
                <tr className='odd:bg-secondaryColor2' key={keys}>
                    <td className="border border-slate-500 p-2 text-center">{keys+1}</td>
                    <td className={`border border-slate-500 py-2 pr-2 ` + (val.tabs ? `pl-${(val.tabs*10)}` : `pl-2`) }>{val.nama_indikator}</td>
                    <td className="border border-slate-500 p-2 text-center">{val.satuan}</td>
                    {
                        listYear.map((item) => {
                            return (
                                <>
                                    <td className="border border-slate-500 p-2 text-center">{val[`t_${item}`]}</td>
                                    <td className="border border-slate-500 p-2 text-center">{val[`r_${item}`]}</td>
                                    <td className="border border-slate-500 p-2 text-center">
                                        {
                                            (val['s_'+item] !== null && val['s_'+item] !== "") ? 
                                            <span className={`py-1 px-2 border rounded-md text-white text-nowrap text-[8px] no-wrap ${val['s_'+item] == "Tercapai" ? "bg-green-500 border-green-200" :"bg-red-600 border-red-200"}`}>
                                                {val[`s_${item}`]}
                                            </span> : null
                                        }
                                        
                                    </td>
                                </>
                            )
                        })
                    }
                </tr>
            )
        })
    }

    // React.useEffect(() => {
    //     console.log(iupState.data);
    // },[iupState.data])
    return (
        <Layout
            loading={false}
            breadCrumbsData={breadCrumbsData}
        >
            <div
                className="bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full"
            >

                <div className="flex-grow bg-white rounded-xl py-2 relative">
                    <h3 className="text-lg font-bold text-primeColor1 text-center">Indikator Utama Pembangunan</h3>
                    <hr className="mb-3" />
                </div>
                {/* <div className="flow-grow bg-white rounded-xl py-2 relative flex justify-end items-end">
                    <div className="lg:w-1/3 md:w-1/2 w-full flex gap-2 flex-col">
                        <PeriodeRpjmdSelector selectedValue={selectedPeriode} onChangeAction={onchangeperiode} />
                    </div>
                </div> */}
                <div className="w-full flex flex-col justify-center sm:overflow-visible overflow-x-auto">
                    <table className="w-full table-auto text-xs mb-4">
                        <thead className="bg-primeColor1 text-white sticky top-0">
                            <tr>
                                <th className="border border-slate-500 md:w-[1%]" rowSpan={3}>
                                    No
                                </th>
                                <th className="border border-slate-500 md:w-1/4" rowSpan={3}>
                                    Indikator
                                </th>
                                <th className="border border-slate-500 md:w-1/12" rowSpan={3}>
                                    Satuan
                                </th>
                                <th className="border border-slate-500" colSpan={listYear.length * 3}>
                                    Tahun
                                </th>
                            </tr>
                            <tr>
                                {
                                    listYear.map((item) => {
                                        return (
                                            <th className="border border-slate-500" colSpan={3}>{item}</th>
                                        )
                                    })
                                }
                            </tr>
                            <tr>
                                {
                                    listYear.map((item) => {
                                        return (
                                            <>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Target</span>
                                                    <span className="md:hidden block">T</span>
                                                </th>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Realisasi</span>
                                                    <span className="md:hidden block">R</span>
                                                </th>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Status</span>
                                                    <span className="md:hidden block">S</span>
                                                </th>
                                            </>
                                        )
                                    })
                                }
                            </tr>
                            
                        </thead>
                        <tbody>
                            {
                                    iupState.data ? iupState.data.map((item, keys) => {
                                    const indikator = renderIndikator(item.indikator)
                                    const misi = (
                                        <>
                                            <tr key={keys}>
                                                <td className="border border-slate-500 py-3 px-5 bg-primeColor2 text-primeColor1 font-bold text-md" colSpan="100%">{item.nama_aspek}</td>
                                            </tr>
                                            {
                                                indikator
                                            }
                                        </>
                                    )
                                    return (misi)
                                }) : 
                                <tr>
                                    <td className="border border-slate-500 py-2 px-5 bg-green-200" colSpan="100%">Loading...</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <BackButton backLink={'/tahun/'+yearconfig} />
        </Layout>
    )
}



const mapStateToProps = (state) => ({
    periodeState: state.newsakatoplanState.periodeRpjmd,
    iupState: state.newsakatoplanState.dataIup
})

const mapDispatchToProps = {
    getDataIup: getDataIup_newSakatoplan_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, React.memo)(DataIup)